// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/banner-mid-page-white-item/banner-mid-page-white-item.component.scss
// module id = 145
// module chunks = 0